import {Injectable} from '@angular/core';
import {BaseDao} from '../../../../base-dao';
import {MarketplaceProductComment} from '../../../../models';
import {KluhManagerValidator} from '../../../../validators/kluh-manager-validator';
import {Observable} from 'rxjs/internal/Observable';
import {R2CloudHttpApiService} from '../../../../r2-cloud-http-api.service';

@Injectable()
export class MarketplaceProductCommentDaoService extends BaseDao<MarketplaceProductComment> {
    constructor(http: R2CloudHttpApiService, validatorDAO: KluhManagerValidator) {
        super(http, validatorDAO, 'marketplace-product-comment');
    }

    findAllByMarketplaceProductId(marketplaceProductId: number): Observable<MarketplaceProductComment[]> {
        return this.http.get<MarketplaceProductComment[]>(this.url + '/find-all-by-marketplace-product-id/' + marketplaceProductId);
    }
}
